<template>
  <div>
    <page-toolbar>
      <period-control v-model="periodId" @change="periodChange" show-all-period-item>
      </period-control>
      <kendo-dropdownlist
        v-model="auditTypeId"
        :data-source="auditTypeDataSource"
        :data-text-field="'auditTypeName'"
        :data-value-field="'auditTypeId'"
      ></kendo-dropdownlist>
    </page-toolbar>
    <div style="height:calc(100vh - 170px)" ref="auditLogGrid"></div>
  </div>
</template>

<script>
import $ from '@/helpers/jquery-bridge'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import PeriodControl from '@/components/PeriodControl'
import {enableExportExcel} from '@/helpers/export-helper'

export default {
  name: 'AuditLog',
  components: {
    PageToolbar,
    PeriodControl,
  },
  mounted() {
    let grid = $(this.$refs.auditLogGrid)
      .kendoGrid({
        autoBind: false,
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 16,
          transport: {
            read: {
              type: 'GET',
              url: '/api/AuditLog/getAuditLogData',
              data: () => ({
                clientId: this.clientId,
                auditTypeId: this.auditTypeId,
                startDate: this.startDate,
                endDate: this.endDate,
              }),
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'auditLogId',
              fields: {
                auditTypeId: {type: 'number'},
                clientId: {type: 'number'},
                clientName: {type: 'string'},
                groupId: {type: 'string'},
                identifier: {type: 'string'},
                field: {type: 'string'},
                oldValue: {type: 'string'},
                newValue: {type: 'string'},
                user: {type: 'string'},
                lastModified: {type: 'date'},
                comment: {type: 'string'},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {
            field: 'clientName',
            title: 'Client',
            width: 200,
            attributes: {style: 'text-align: left;'},
            hidden: !this.isMaster,
          },
          {field: 'groupId', title: 'Group Id', width: 132},
          {field: 'identifier', title: 'Identifier', width: 232},
          {field: 'field', title: 'Field', width: 182},
          {field: 'oldValue', title: 'Old Value', width: 282},
          {field: 'newValue', title: 'New Value', width: 282},
          {field: 'user', title: 'User', width: 232},
          {
            field: 'lastModified',
            title: 'Last Modified',
            width: 161,
            format: '{0:yyyy-MM-dd HH:mm:ss}',
          },
          {field: 'comment', title: 'Comment', width: 161},
          {},
        ],
      })
      .getKendoGrid()

    enableExportExcel(grid, '/api/AuditLog/exportToExcel', $('.page_toolbar-item'))
  },
  data() {
    return {
      auditTypeDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            type: 'GET',
            url: '/api/AuditLog/getAuditLogTypes',
            contentType: 'application/json',
          },
        },
        requestEnd: ({response}) => {
          if (response) {
            const [first] = response
            this.auditTypeId = first.auditTypeId
          }
        },
      }),
      periodId: -1,
      auditTypeId: 1,
      startDate: '2019-01-01',
      endDate: '2019-12-31',
    }
  },
  methods: {
    refreshGrid() {
      let grid = $(this.$refs.auditLogGrid).getKendoGrid()
      grid.dataSource.read()
    },
    updateGridColumns() {
      let grid = $(this.$refs.auditLogGrid).getKendoGrid()
      let columnName = ''
      switch (Number(this.auditTypeId)) {
        case 1:
          columnName = 'Group Id'
          grid.showColumn('groupId')
          grid.hideColumn('identifier')
          break
        case 2:
          columnName = 'Operation Code'
          grid.showColumn('groupId')
          grid.showColumn('identifier')
          grid.resizeColumn(grid.columns[2], 132)
          break
        case 4:
          columnName = 'Identifier'
          grid.hideColumn('groupId')
          grid.showColumn('identifier')
          grid.resizeColumn(grid.columns[2], 232)
          break
        case 5:
          columnName = 'Number'
          grid.showColumn('groupId')
          grid.showColumn('identifier')
          grid.resizeColumn(grid.columns[2], 132)
          break
      }
      $('.k-grid th[data-field=identifier] a.k-link').html(columnName)
      grid.dataSource.filter([])
    },
    periodChange(e) {
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.refreshGrid()
    },
  },
  watch: {
    auditTypeId(value) {
      if (value == null) return

      this.refreshGrid()
      this.updateGridColumns()
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    isMaster() {
      return this.clientId == 0
    },
  },
}
</script>
